// extracted by mini-css-extract-plugin
module.exports = {"container":"account-password-reset-confirmation_container__uy1qu"};